import * as React from 'react';
import styles from '../../../styles/global.module.css';
import type { DynamicComponentProps } from '@/types/commontypes';
import { Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import type { FC } from 'react';
import { useState } from 'react';

const ExtendOption: FC<DynamicComponentProps<[boolean, boolean]>> = ({ label, value = [false, false], onChange }) => {
  const [left, setLeft] = useState<boolean>(value[0] ?? false);
  const [right, setRight] = useState<boolean>(value[1] ?? false);

  const handleLeftChange = () => {
    const newLeft = !left;
    setLeft(newLeft);
    onChange([newLeft, right]);
  };

  const handleRightChange = () => {
    const newRight = !right;
    setRight(newRight);
    onChange([left, newRight]);
  };

  return (
    <div className={styles.property_row}>
      <label className={styles.property_label}>{label}</label>
      <div className={styles.property_value}>
        <Button
          type={value[0] ? 'primary' : 'default'}
          defaultValue={'false'}
          onClick={() => handleLeftChange()}
          icon={<LeftOutlined />}
          style={{ borderRadius: '6px 0 0 6px' }}
        >
          Left
        </Button>
        <Button
          type={value[1] ? 'primary' : 'default'}
          defaultValue={'false'}
          onClick={() => handleRightChange()}
          style={{ borderRadius: '0 6px 6px 0', marginLeft: '-1px' }}
        >
          Right
          <RightOutlined />
        </Button>
      </div>
    </div>
  );
};

export default ExtendOption;
